import React, { useState } from "react";

import styles from "./Card.module.scss";
import { IoPieChart, IoChevronForward } from "react-icons/io5";
import { IoMdApps } from "react-icons/io";
import { FaPeopleGroup } from "react-icons/fa6";
import { AiFillSchedule, AiOutlineFundView } from "react-icons/ai";
import { GiSandsOfTime } from "react-icons/gi";
import { GrSecure } from "react-icons/gr";
import { IconContext } from "react-icons";
import { motion, AnimatePresence } from "framer-motion";
import Modal from "../../Modal/modal";
import { cardData } from "./cardData";

const container = {
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ease: "easeInOut",
      duration: 0.2,
    },
  },
};

const hoverEffect = {
  whileHover: {
    scale: 1.5,
    rotate: 630,
    borderRadius: "100%",
  },
  whileTap: {
    scale: 0.8,
    rotate: 630,
    borderRadius: "100%",
  },
};

const Card = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalData, setModalData] = useState({ id: 0, title: "", text: "" });

  const close = () => setModalIsOpen(false);

  const open = (id, title, text) => {
    setModalData({ id, title, text });
    setModalIsOpen(true);
  };

  return (
    <>
      <motion.div id="about" className={styles.service_container}>
        <div className={styles.title_wrapper}>
          <motion.span
            className={styles.service_title}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 1.8 }}
          >
            Our Services
          </motion.span>
          <motion.h2
            initial={{ y: 200, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 1 }}
          >
            Save Time Organizing Schedules <br /> For Individuals & Teams
          </motion.h2>
        </div>
        <motion.div
          className={styles.service_card}
          variants={container}
          initial="hidden"
          exit="exit"
          whileInView="show"
          viewport={{ once: false }}
        >
          {/* Map over the entire cardData array to display all cards */}
          {cardData.map((card) => (
            <motion.div className={styles.card} key={card.id} variants={item}>
              <motion.span
                className={styles.service_icon}
                style={{ backgroundColor: card.iconColor }}
                variants={hoverEffect}
                whileHover="whileHover"
                whileTap="whileTap"
              >
                {/* Render the appropriate icon based on the card id */}
                {card.id === 1 && (
                  <IconContext.Provider
                    value={{ color: "#14da8f", size: "22px" }}
                  >
                    <AiFillSchedule />
                  </IconContext.Provider>
                )}
                {card.id === 2 && (
                  <IconContext.Provider
                    value={{ color: "#5700cf", size: "22px" }}
                  >
                    <FaPeopleGroup />
                  </IconContext.Provider>
                )}
                {card.id === 3 && (
                  <IconContext.Provider
                    value={{ color: "#98901d", size: "22px" }}
                  >
                    <IoPieChart />
                  </IconContext.Provider>
                )}
                {card.id === 4 && (
                  <IconContext.Provider
                    value={{ color: "#b8375d", size: "22px" }}
                  >
                    <AiOutlineFundView />
                  </IconContext.Provider>
                )}
                {card.id === 5 && (
                  <IconContext.Provider
                    value={{ color: "#411678", size: "22px" }}
                  >
                    <GiSandsOfTime />
                  </IconContext.Provider>
                )}
                {card.id === 6 && (
                  <IconContext.Provider
                    value={{ color: "#dbf9ed", size: "22px" }}
                  >
                    <GrSecure />
                  </IconContext.Provider>
                )}
                {card.id === 7 && (
                  <IconContext.Provider
                    value={{ color: "#918536", size: "22px" }}
                  >
                    <IoMdApps />
                  </IconContext.Provider>
                )}
                {card.id === 8 && (
                  <IconContext.Provider
                    value={{ color: "#ffffff", size: "22px" }}
                  >
                    {/* icon for ID 8 */}
                    <IoMdApps />
                  </IconContext.Provider>
                )}
              </motion.span>
              <h3>
                {/* Split the title into two parts and add a <br> tag between them */}
                {card.title.split(" ").map((part, index) => (
                  <React.Fragment key={index}>
                    {part}
                    {index !== card.title.split(" ").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h3>
              <div className="content">
                <span>Learn More</span>
                <motion.button
                  className={styles.cardButton}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => open(card.id, card.title, card.text)}
                >
                  <IconContext.Provider
                    value={{ color: "#14da8f", size: "18px" }}
                  >
                    <IoChevronForward />
                  </IconContext.Provider>
                </motion.button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>

      <AnimatePresence initial={false} mode="wait" onExitComplete={() => null}>
        {modalIsOpen && (
          <Modal
            modalIsOpen={modalIsOpen}
            handleClose={close}
            id={modalData.id}
            title={modalData.title}
            text={modalData.text}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default Card;
